<template>
    <div>
        <div class="input-btn--icon-left">
            <label class="btn btn--subtle btn--icon-left" @click="showCapture">
                <i class="icon-camera"></i>
                {{messages.questionnaire_take_photo_btn}}
            </label>
        </div>
        <br>
        <br>
        <div class="input-btn--icon-left">
            <label class="btn btn--subtle btn--icon-left">
                <i class="icon-picture"></i>
                {{messages.questionnaire_select_photo_btn}}
            </label>
            <input type="file" accept="image/*" @change="uploadImage">
        </div>

        <br>
        <br>
        <div class="upload-photo__container">
            <photos-display
                    v-for="photo in photosReversed"
                    v-bind="photo"
                    :key="photo.id"
                    @removed="handlePhotoRemoved">
            </photos-display>
        </div>
    </div>
</template>

<script>
    import loadImage from 'blueimp-load-image';
    import {QuestionnaireApi as api} from "../../api";
    import {Bovemij, Mixins, Utils} from "@bvm/core";
    import PhotoTakingModal from "./photo-taking-modal";
    import PhotosDisplay from "./photos-display";

    export default {
        mixins: [Mixins.Lang],
        components: {PhotosDisplay},
        props: {
            scanId: {type: String, required: true},
            questionId: {type: String, required: true},
            photos: {type: Array, required: true},
        },
        data() {
            return {
                messageKeys: [
                    'questionnaire_take_photo_btn',
                    'questionnaire_select_photo_btn',
                ],
                stats: {
                    width: null,
                    height: null
                },
                photosReversed: (this.photos || []).slice().sort().reverse().map(id => ({id: id})),
                uploadingPhotos: 0
            };
        },
        mounted() {
            Utils.Event.EventBus.$on('webCamPhotoCaptured', this.webCamPhotoCaptured);
        },
        destroyed() {
            Utils.Event.EventBus.$off('webCamPhotoCaptured', this.webCamPhotoCaptured);
        },
        methods: {
            showCapture() {
                Utils.Event.EventBus.$emit(Bovemij.Events.OPEN_ROOT_MODAL, {
                    component: PhotoTakingModal,
                    cssClass: 'modal__phototaking',
                    zIndex: 1200
                });
            },
            webCamPhotoCaptured(base64WebCamCapture) {
                this.addPhoto({
                    src: base64WebCamCapture,
                    width: this.stats.width,
                    height: this.stats.height
                });
            },
            handlePhotoRemoved(id) {
                let self = this;
                api.deletePhoto(id).then(function () {
                    for (let i = 0; i < self.photosReversed.length; i++) {
                        if (self.photosReversed[i].id === id) {
                            self.photosReversed.splice(i, 1);
                        }
                    }
                    for (let j = 0; j < self.photos.length; j++) {
                        if (self.photos[j] === id) {
                            self.photos.splice(j, 1);
                        }
                    }
                });
            },
            uploadStarted() {
                this.uploadingPhotos++;
            },
            uploadFinished() {
                this.uploadingPhotos--;
            },
            addPhoto(previewData) {
                loadImage(previewData.src,
                    (img) => this.imageCallback(img, this, {type: 'image/png'}),
                    {
                        maxWidth: 1440,
                        maxHeight: 1440,
                        orientation: true,
                        canvas: true
                    }
                )
            },
            uploadImage(event) {
                const file = event.target.files[0];
                event.target.value = '';
                loadImage(file,
                    (img) => this.imageCallback(img, this, file),
                    {
                        maxWidth: 1440,
                        maxHeight: 1440,
                        orientation: true,
                        canvas: true
                    }
                )
            },
            imageCallback(img, vm, file) {
                const photo = {
                    uploading: true,
                    uploadProgress: 0
                };

                if (img.type === "error") {
                    console.error("Error loading image ", file);
                } else {
                    // Render thumbnail.
                    photo.base64 = img.toDataURL();
                    vm.photosReversed.unshift(photo);

                    img.toBlob(function (blob) {

                        vm.uploadStarted();
                        // upload
                        api.uploadPhoto(
                            vm.scanId,
                            vm.questionId,
                            file.type,
                            blob,
                            function (progress) {
                                photo.uploadProgress = progress;
                            })
                            .then(function (id) {
                                photo.id = id;
                                photo.uploading = false;
                                vm.uploadFinished();
                                vm.photos.push(photo.id);
                            });
                    });
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .overlay {
        height: 100%;
        width: 100%;
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.9);

        .controls {
            background-color: rgba(255, 255, 255, .75);
            width: 15%;
            height: 100%;
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }

        video, #preview {
            object-fit: contain;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }

        .preview {
            display: none
        }

    }

    .overlay-content.previewing video {
        display: none
    }

</style>
